import { IconButton } from '@mui/material'
import { EditNote } from '@mui/icons-material'
import React, { useEffect, useRef, useState } from 'react'
import { ApiCall, DropDownData } from '../CommonComponents/CustomHooks'
import { NotificationSound } from '../CommonComponents/CommonNotification'

const UserProfile = () => {
    const inputrefs = useRef([])
    const GetGroupName = DropDownData('GetGroupName')
    const [ToggleEdit, setToggleEdit] = useState(false)
    const [formData, setFormData] = useState({
        userCode: '',
        userName: '',
        address: '',
        groupName: '',
        mobileNo: '',
        emailID: '',
        pinCode: '',
        city: '',
        profileImage: '',
        profileImageName: '',
        profileImageExtension: ''
    })

    const GetUserDetails = async (CurrentPage) => {
        const data = {
            Type: 'S'
        }
        let res = await ApiCall(`/api/User/FillUserProfileDetails`, data)
        if (res.status === "SUCCESS") {
            setFormData({
                "userCode": res.userCode,
                "userName": res.userName,
                "address": res.address,
                "userGroupName": res.userGroupName,
                "mobileNo": res.mobileNo,
                "emailID": res.emailID,
                "pinCode": res.pinCode,
                "city": res.city,
                "base64Img": res.base64Img,
                "logoExt": res.logoExt,
                "logoName": res.logoName
            })
        }
        if (res.status === "ERROR") {
            await NotificationSound(res.status, res.Message, res.focus, inputrefs);
        }
        if (res.status === 'EXPIRED') {
            await NotificationSound(res.status, res.Message, res.focus, inputrefs);
        }
    }
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                setFormData(prevFormData => ({
                    ...prevFormData,
                    base64Img: reader.result,
                    logoName: fileName,
                    logoExt: fileExtension,
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                setFormData(prevFormData => ({
                    ...prevFormData,
                    base64Img: reader.result,
                    logoName: fileName,
                    logoExt: fileExtension,
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const UpdateUserDetails = async () => {
        let data = await ApiCall(`/api/User/UpdateUserProfilePhoto`, { ...formData })
        if (data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs);
            setToggleEdit(false)
        } else if (data.status === 'ERROR') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs);
        }
    }

    useEffect(() => {
        GetUserDetails()
    }, [])


    return (
        <>
            <div className="row">
                <div className="col-md-12 col-xl-12">
                    <div className="card border-0 " style={{ marginBottom: "16px" }}>
                        <div className="profile_tab" style={{ padding: "19px" }}>
                            <div className='card-headerProfile mb-1 border-bottom d-flex justify-content-between align-items-center' style={{ backgroundColor: "#dbeaff" }}>
                                <h6 className="m-0 p-2" style={{ fontWeight: "bold" }}>  {'User Profile'} </h6>
                                <div style={{ cursor: 'pointer', display: "none" }} onClick={() => setToggleEdit(!ToggleEdit)}>
                                    <span>Edit Info :</span>
                                    <IconButton >
                                        <EditNote />
                                    </IconButton>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 d-flex flex-column align-items-center">
                                    <div>
                                        <div className="mt-3 d-flex justify-content-center">
                                            <img
                                                src={formData.base64Img || './images/avatar.png'}
                                                alt="User Avatar"
                                                style={{
                                                    width: '130px',
                                                    height: '130px',
                                                    borderRadius: '50%',
                                                    marginTop: '5px',
                                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'
                                                }}
                                            />
                                        </div>
                                        <div
                                            className='photo_uploader w-100 text-center mt-3'
                                            style={{ cursor: 'pointer', border: '2px dashed #ddd', padding: '20px', position: 'relative' }}
                                            onDrop={handleDrop}
                                            onDragOver={handleDragOver}
                                        >
                                            <input
                                                id="file-upload"
                                                className='d-none'
                                                type="file"
                                                name="fileUpload"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                            />
                                            <label htmlFor="file-upload" id="file-drag" style={{ cursor: 'pointer' }}>
                                                <div id="start">
                                                    <i className="fa fa-download fs-4 text-theme mb-2" aria-hidden="true"></i>
                                                    <h6>Upload a Photo</h6>
                                                </div>
                                                <button type="button" name='btn'
                                                    onClick={UpdateUserDetails}
                                                    className="btn btn-rounded btn-success">
                                                    <span className=" text-white me-2">
                                                        <i className="fa fa-upload color-warning">
                                                        </i>
                                                    </span>Update</button>
                                            </label>
                                            <span className='mt-2 d-block text-secondary'>File Format : png, jpg 200x200</span>
                                        </div>
                                    </div>
                                </div><div className="col-md-8">
                                    <div className="tab_body profile_body py-4">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="userCode" className="form-label">User Code</label>
                                                    <input
                                                        type="text"
                                                        id="userCode"
                                                        className="form-control"
                                                        placeholder="User Code"
                                                        value={formData.userCode}
                                                        onChange={(e) => setFormData({ ...formData, userCode: e.target.value })}
                                                        disabled={!ToggleEdit}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="userName" className="form-label">User Name</label>
                                                    <input
                                                        type="text"
                                                        id="userName"
                                                        className="form-control"
                                                        placeholder="User Name"
                                                        value={formData.userName}
                                                        onChange={(e) => setFormData({ ...formData, userName: e.target.value })}
                                                        disabled={!ToggleEdit}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="userGroupName" className="form-label">Group Name</label>
                                                    <select
                                                        id="userGroupName"
                                                        className="form-control"
                                                        value={formData.userGroupName}
                                                        disabled
                                                        onChange={(e) => setFormData({ ...formData, userGroupName: e.target.value })}
                                                    >
                                                        <option value=''>--Please Select--</option>
                                                        {GetGroupName?.data?.dataList?.map((item, index) => (
                                                            <option key={item.name + index} value={item.name}>{item.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="mobileNo" className="form-label">Mobile No</label>
                                                    <input
                                                        type="text"
                                                        id="mobileNo"
                                                        className="form-control"
                                                        placeholder="Mobile No"
                                                        value={formData.mobileNo}
                                                        onChange={(e) => setFormData({ ...formData, mobileNo: e.target.value })}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-1">
                                                    <label htmlFor="emailID" className="form-label">Email Address</label>
                                                    <input
                                                        type="email"
                                                        id="emailID"
                                                        className="form-control"
                                                        placeholder="Email Address"
                                                        value={formData.emailID}
                                                        onChange={(e) => setFormData({ ...formData, emailID: e.target.value })}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-1">
                                                    <label htmlFor="address" className="form-label">Address</label>
                                                    <textarea
                                                        id="address"
                                                        className="form-control"
                                                        placeholder="Address"
                                                        value={formData.address}
                                                        onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                                        disabled={!ToggleEdit}
                                                        rows="3"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default UserProfile;
